import { Info } from "@mui/icons-material";
import CustomButtonSimple from "../../components/CustomMiscellaneous/CustomButtonSimple";
import CustomTitle from "../../components/CustomMiscellaneous/CustomTitle";
import { generalObjectBuilder, genericDelete, genericPost, genericUpdate, NOTAS_ENCOMENDA_EXTENSION, paginatedGetWithProcessor } from "../../services/api.service";
import TableView from "../Common/TableView";
import { NotasEncomendaTableConfigs } from "./NotasEncomenda.config";
import { useState } from "react";
import Modal from 'react-modal';

function InstrucoesDeCompra() {

    const [instrucoesOpen, setInstrucoesOpen] = useState(false);


    return (
        <>
            {
                instrucoesOpen ?
                    <Modal className={"justify-self-center justify-center flex w-full h-full p-32 px-20 z-[1000]"} isOpen={instrucoesOpen}>
                        < div className="bg-white opacity-100 flex flex-col w-4/5 rounded-md shadow-lg z-[1200] h-fit" >
                            <div className="flex w-full justify-between  bg-rodrimaq-red rounded-t-md p-3">
                                <div className="text-white font-bold">Instruções de compra</div>
                                <div className="text-white cursor-pointer hover:underline" onClick={() => setInstrucoesOpen(false)}>Fechar</div>
                            </div>
                            <div className="p-5 px-12">
                                <div className="text-lg">
                                    <div ><span className="font-bold">1.</span> Consultar ocorrências App Rodrimaq</div>
                                    <hr className="mb-5" />
                                    <div><span className="font-bold">2.</span> Consultar fornecedores</div>
                                    <hr className="mb-5" />
                                    <div><span className="font-bold">3.</span> Analisar proposta fornecedores e avaliar a melhor solução</div>
                                   
                                    <hr className="mb-5" />
                                    <div ><span className="font-bold">4.</span> Fazer nota de encomenda</div>
                                    <hr className="mb-5" />
                                    <div ><span className="font-bold">5.</span> Validação da entrada material</div>
                                    <hr className="mb-5" />
                                </div>
                            </div>
                        </div >
                    </Modal >
                    : null
            }


            <CustomButtonSimple color="#3498eb" className="mr-4" text={"Instruções de compra"} onClick={() => setInstrucoesOpen(true)} Icon={Info} />
        </>
    )



}



export default function NotasEncomenda() {

    return (<div>
        <TableView
            title={"Notas de Encomenda"}

            postEntity={genericPost(NOTAS_ENCOMENDA_EXTENSION)}
            editEntity={genericUpdate(NOTAS_ENCOMENDA_EXTENSION)}
            deleteEntity={genericDelete(NOTAS_ENCOMENDA_EXTENSION)}
            addButtonText={"Nova Nota de Encomenda"}
            extraActions={<InstrucoesDeCompra />}
            tableConfigs={NotasEncomendaTableConfigs}
            dataBuildFunction={generalObjectBuilder(NotasEncomendaTableConfigs)}
            entityName={"Nota Encomenda"}
            idProp={"id"}
            reroute={true}
            generatePdf={true}
            allowCopy={true}
        />
    </div>)

}
